<template>
  <v-dialog
    v-model="dialog"
    :max-width="400"
    :retain-focus="false"
    @click:outside="cancel"
    @keydown.esc="cancel"
    @keydown.enter="submit"
  >
    <v-card outlined>
      <v-card-title>
        {{ $t('wordpress.addEndpoint') }}
        <p-btn-icon
          type="close"
          btn-class="mr-n3 ml-auto"
          @click="cancel"
        ></p-btn-icon>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-container>
            <v-row dense align="center" justify="end">
              <v-col>
                <div>
                  <div class="subtitle-2">{{ $t('wordpress.pluginHelpTextHeader') }}</div>
                  {{ $t('wordpress.pluginHelpText') }}
                </div>
                <v-text-field
                  v-model.trim="url"
                  :loading="urlLoading"
                  :rules="[rule.required(), rule.url()]"
                  validate-on-blur
                  :label="$t('wordpress.endpointURL')"
                  class="mt-2"
                  type="url"
                  clearable
                  @change="onUrlChange"
                ></v-text-field>
                <div
                  v-if="showUrlError"
                  class="red--text darken-3"
                >
                  {{ $t('wordpress.endpointValidationError') }}
                  <br/>
                  {{ urlErrorDetails }}
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="justify-center">
        <v-btn text @click="cancel">{{ $t('cancel') }}</v-btn>
        <v-btn text color="primary" @click="submit">{{ $t('save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import axios from 'axios'

import validationMixin from '@/mixins/validation.mixin.js'

import PBtnIcon from '@/components/PBtnIcon'


export default {
  components: {
    PBtnIcon
  },


  mixins: [
    validationMixin
  ],


  data () {
    return {
      valid: true,
      dialog: true,
      showUrlError: false,
      urlErrorDetails: null,
      urlLoading: false,
      url: null,
      result: null
    }
  },


  methods: {
    onUrlChange () {
      this.showUrlError = false
      this.urlErrorDetails = null
    },

    async submit () {
      if (this.$refs.form.validate() === false) return

      try {
        this.urlLoading = true
        const pluginUrl = new URL(process.env.VUE_APP_WORDPRESS_PLUGIN_RELATIVE_URL, this.url)
        const pluginResponse = await axios.get(pluginUrl.href)

        if (pluginResponse.status === 200) {
          this.result = {
            url: this.url
          }
          this.dialog = false
          this.$destroy()
        } else {
          this.urlErrorDetails = pluginResponse.statusText
          this.showUrlError = true
        }
      } catch (error) {
        this.urlErrorDetails = error
        this.showUrlError = true
        this.$log.error(error)
      } finally {
        this.urlLoading = false
      }
    },

    cancel () {
      this.result = null
      this.dialog = false
      this.$destroy()
    }
  }
}
</script>
